import type React from "react";

export interface FileInfoCardProps {
  fileName: string;
  fileSizeBytes: number;
  rowCount: number;
  onRemove: () => void;
  className?: string;
}

function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "kb", "mb", "gb", "tb"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = bytes / Math.pow(k, i);
  const formatted =
    value < 10 && value >= 1 ? value.toFixed(1) : value.toFixed(0);
  return `${formatted} ${sizes[i]}`;
}

const FileInfoCard: React.FC<FileInfoCardProps> = ({
  fileName,
  fileSizeBytes,
  rowCount,
  onRemove,
  className = "",
}) => (
  <div
    className={`import-payslip-events__file-info-card ${className}`.trim()}
    role="region"
    aria-label={`Selected file: ${fileName}`}
  >
    <div className="import-payslip-events__file-info-card-content">
      <div className="import-payslip-events__file-info-card-icon">
        <span className="pi pi-file-excel" aria-hidden />
      </div>
      <div className="import-payslip-events__file-info-card-details">
        <p className="import-payslip-events__file-info-card-name">{fileName}</p>
        <p className="import-payslip-events__file-info-card-meta">
          CSV Document. File Size: {formatFileSize(fileSizeBytes)}. {rowCount}{" "}
          row{rowCount !== 1 ? "s" : ""}.
        </p>
      </div>
    </div>
    <button
      type="button"
      className="import-payslip-events__file-info-card-remove"
      onClick={onRemove}
      aria-label="Remove file"
    >
      <span className="pi pi-times" aria-hidden />
    </button>
  </div>
);

export default FileInfoCard;
